module.exports = __webpack_public_path__ + "static/media/Graviola-Regular.19680293.otf";